module.exports = __webpack_public_path__ + "img/status.87c2c274.jpg";